import { Box, Typography } from '@mui/material'
import SharedDialog from '../../../../shared/components/Dialog'
import ServerErrorGif from '../../../../assets/images/servererror.gif'

// Network Error Dialog Component
const NetworkErrorDialog = ({ networkError, handleCloseDialog }) => {
  return (
    <SharedDialog variant="content" open={networkError} onClose={handleCloseDialog} width={436} height={355}>
      <Box display="flex" flexDirection="column" alignItems="center" sx={{ m: 2, textAlign: 'center' }}>
        <img src={ServerErrorGif} alt="Server Error" />
        <Typography sx={{ fontSize: '24px', fontWeight: 700 }}>Server Error</Typography>
      </Box>
    </SharedDialog>
  )
}

export default NetworkErrorDialog
